import { constants } from '@atc/bonnet-seo';
import pageNames from './pageNames';
import funnels from './funnels';
const {
  FIND_CAR
} = funnels;
const {
  SEARCH_RESULTS
} = pageNames;
export default async function processPathname(_ref) {
  let {
    query,
    pageName,
    pathname,
    brand,
    basePath
  } = _ref;
  switch (pageName) {
    case SEARCH_RESULTS:
      {
        let listingTypeSuffix = '';
        if (brand === 'atc' || brand === 'carAndDriver') {
          // if the brand is ATC update any listingType parameter to include `-cars` suffix;
          // Note: the listingTypeSuffix is not used for CAR_AND_DRIVER
          if (brand === 'atc') {
            listingTypeSuffix = `-${constants.CARS}`;

            // update any listingType parameter to include `-cars` suffix;
            pathname = pathname.replace(/\/(new|used|certified|third-party-certified|all)(?=$|\/)/gi, `/$1${listingTypeSuffix}`);
          }
          // Applies to both ATC and CAR_AND_DRIVER
          // If the SRP path has a listingType encoded as a `used` segment (e.g.: '/used-car' for ATC, and '/used' for carAndDriver)
          // AND has any other seo pathname encoded, then
          // we remove the `used` segment as the other SEO param will allow the route to be directed to the SRP
          // Examples:
          // ATC: /cars-for-sale/used-cars/chevrolet => cars-for-sale/chevrolet
          // CAR_AND_DRIVER: /cars-for-sale/used/chevrolet => cars-for-sale/chevrolet
          const usedCarsSegment = `/used${listingTypeSuffix}`;
          const usedCarDefaultSegmentCount = basePath ? 3 : 2;
          if (pathname.includes(usedCarsSegment) && pathname.split('/').length > usedCarDefaultSegmentCount) {
            const re = new RegExp(usedCarsSegment);
            pathname = pathname.replace(re, '');
          }

          // remove listing types not allowed in seo section of the url - ensure it is just added as a query param
          const thirdPartySegment = `/third-party-certified${listingTypeSuffix}`;
          if (pathname.includes(thirdPartySegment)) {
            const re = new RegExp(thirdPartySegment);
            pathname = pathname.replace(re, '');
            query.listingType = ['3P_CERT'];
          }
        }

        // after all processing if the pathname is reduced to just the funnel name
        // then we append 'searchresults.xhtml' for backwards compatibility
        if (pathname === `/${FIND_CAR}`) {
          pathname = `/${FIND_CAR}/searchresults.xhtml`;
        }
        break;
      }
    default:
      break;
  }
  return {
    query,
    pathname
  };
}